/**
 * sale_detail_status から sale_status を導出する。
 * 1〜4 → 1（可）
 * 5〜6 → 0（不可）
 * 7 / 0（不明） / null → null（ブランク）
 */
export const deriveSaleStatus = (
  saleDetailStatus: number | string | null | undefined
): 0 | 1 | null => {
  if (saleDetailStatus == null || saleDetailStatus === "") {
    return null;
  }
  const detail = Number(saleDetailStatus);
  if (Number.isNaN(detail)) {
    return null;
  }
  if (detail >= 1 && detail <= 4) {
    return 1;
  }
  if (detail >= 5 && detail <= 6) {
    return 0;
  }
  return null;
};
